/* web/style.css "results list" */
.head { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; }
.head h3 { flex: 1; margin: 0; font-size: 18px; font-weight: 700; }
.result { display: flex; gap: 12px; width: 100%; text-align: left; border: 0; background: var(--surface); padding: 14px; margin-bottom: 12px; border-radius: var(--radius); box-shadow: var(--shadow); transition: box-shadow .2s, transform .2s; }
.result:hover { box-shadow: 0 0 0 1px rgba(0, 0, 0, .02), 0 6px 20px rgba(0, 0, 0, .14); }
.text { flex: 1; min-width: 0; }
.t { font-weight: 600; }
.rel { font-size: 14px; font-weight: 500; margin-top: 2px; }
.meta { font-size: 14px; color: var(--muted); }
.empty { text-align: center; color: var(--muted); padding: 30px 10px; }
.empty b { display: block; color: var(--text); margin-bottom: 4px; }
